import { CheckAndSendFormStepConfiguration } from '@/api/interfaces/configuration/form/steps/checkAndSendFormStepConfiguration';

export const checkAndSendConfiguration: CheckAndSendFormStepConfiguration = {
    fields: {},
    redirects: {
        applications: {
            stepCompensationError: 'antragabsenderuecksetzungsfehler',
        },
    },
};
